module.exports = __webpack_public_path__ + "img/ItemDefault.bf82796f.svg";